import * as React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface SEOSectionProps {
  metaTitle: string;
  metaDescription: string;
  focusKeyword?: string;
  onMetaTitleChange: (value: string) => void;
  onMetaDescriptionChange: (value: string) => void;
  onFocusKeywordChange?: (value: string) => void;
}

export function SEOSection({
  metaTitle,
  metaDescription,
  focusKeyword,
  onMetaTitleChange,
  onMetaDescriptionChange,
  onFocusKeywordChange,
}: SEOSectionProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center">
          <svg className="w-5 h-5 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          SEO Settings
        </h3>
      </div>
      <div className="p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Meta Title
          </label>
          <Input
            value={metaTitle}
            onChange={(e) => onMetaTitleChange(e.target.value)}
            placeholder="SEO title for search engines..."
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Meta Description
          </label>
          <Textarea
            rows={2}
            value={metaDescription}
            onChange={(e) => onMetaDescriptionChange(e.target.value)}
            placeholder="Description that appears in search results..."
            className="resize-none"
          />
        </div>
        {onFocusKeywordChange && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Focus Keyword
            </label>
            <Input
              value={focusKeyword || ""}
              onChange={(e) => onFocusKeywordChange(e.target.value)}
              placeholder="Main keyword for this post..."
            />
          </div>
        )}
      </div>
    </div>
  );
}